import React, { useEffect, useRef, useState, useCallback, useContext } from "react";
import api, { BASE_URL } from "../../Utils/api";
import { Badge } from "react-bootstrap";
import UsuarioModal from "./UsuariosModal";
import GridPadrao from "../GridPadrao/GridPadrao";
import PageHeader from "../PageHeader/PageHeader";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalContext } from "../../Utils/GlobalContext";


function Usuario({ modoAutoConfig = false }) {
  const [usuarios, setUsuarios] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const { globalData } = useContext(GlobalContext); // ✅ useContext dentro do componente
  const entidadeID = globalData?.entidade_id || localStorage.getItem("entidade_id"); // ✅ agora pode
  const token = localStorage.getItem("authToken");
  const usuarioLogadoId = modoAutoConfig ? localStorage.getItem("user_id") : null;
  const tipoCorrigidoRef = useRef(false);

  // Item #36 (LGPD): globalData.lgpdOcultarDados é buscado centralmente em App.js
  // (uma vez por entidade ativa, para qualquer tela) — null/ausente é tratado
  // como "oculta" (falha segura). cpf/data_nascimento são mascarados (não mais
  // excluídos) via exportMaskColumns do GridPadrao; senha nunca é exportada,
  // independente do LGPD (é segurança, não privacidade).
  const lgpdAtivo = globalData?.lgpdOcultarDados !== false;
  const exportMaskColumns = lgpdAtivo ? { cpf: "cpf", data_nascimento: "data_nascimento" } : {};
  const exportExcludeColumns = ["senha"];

  const permiteEdicao = "S"; // Ajuste para "S" ou "N"

  const TIPO_MAP = {
    A: { label: "Administrador", bg: "info" },
    N: { label: "Normal",        bg: "secondary" },
    C: { label: "Comunicado",    bg: "warning" },
  };

  const columns = [
    { Header: "Nome",    accessor: "nome" },
    { Header: "Email",   accessor: "email" },
    {
      Header: "Tipo",
      accessor: "tipo",
      Cell: ({ row }) => {
        const entry = TIPO_MAP[row.tipo] || { label: row.tipo || "—", bg: "secondary" };
        return <Badge bg={entry.bg} pill>{entry.label}</Badge>;
      },
    },
    { Header: "Situação", accessor: "situacao" },
  ];

  const fetchUsuarios = useCallback(() => {
    if (!entidadeID) return;
    api
      .get(`${BASE_URL}/api/usuarios/ListarUsuario/${entidadeID}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => setUsuarios(response.data.data))
      .catch((error) => console.error("Erro ao buscar os usuários:", error));
  }, [token, entidadeID]);

  useEffect(() => {
    fetchUsuarios();
  }, [fetchUsuarios]);

  // No contexto de AutoConfiguracao, o usuário logado deve ser sempre tipo "A".
  // Se o banco tiver outro tipo, corrige silenciosamente e recarrega a grid.
  useEffect(() => {
    if (!modoAutoConfig || !usuarioLogadoId || tipoCorrigidoRef.current || !usuarios.length) return;
    const logado = usuarios.find((u) => String(u.id) === String(usuarioLogadoId));
    if (!logado) return;
    tipoCorrigidoRef.current = true;
    if (logado.tipo === "A") return;
    api
      .put(
        `${BASE_URL}/api/usuarios/EditarUsuario/${logado.id}`,
        {
          nome: logado.nome,
          email: logado.email,
          telefone: logado.telefone || null,
          cpf: logado.cpf || null,
          situacao: logado.situacao || "A",
          data_nascimento: logado.data_nascimento || null,
          tipo: "A",
          id_grupo_usuario: null,
        },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      .then(() => fetchUsuarios())
      .catch((err) => console.error("[AutoConfig] Erro ao definir tipo Administrador:", err));
  }, [modoAutoConfig, usuarioLogadoId, usuarios, token, fetchUsuarios]);

  const handleEdit = (user) => {
    setSelectedUser(user);
    setShowModal(true);
  };

  const handleAdd = () => {
    // O limite de usuários operacionais do plano só é checado ao salvar
    // (UsuariosModal.handleSave) — aqui ainda não sabemos se o usuário vai
    // escolher tipo Comunicado, que não conta nesse limite.
    setSelectedUser(null);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedUser(null);
  };

  return (
    <div>
      <PageHeader titulo="Cadastro de Usuários" path="/Usuario" />

      <GridPadrao
        columns={columns}
        data={usuarios}
        onEdit={(configuracao) => handleEdit(configuracao, permiteEdicao)}
        onAdd={handleAdd}
        addDataTour="usuarios-adicionar"
        exportExcludeColumns={exportExcludeColumns}
        exportMaskColumns={exportMaskColumns}
      />

      <UsuarioModal
        show={showModal}
        handleClose={handleClose}
        usuario={selectedUser}
        fetchUsuarios={fetchUsuarios}
        usuarioLogadoId={usuarioLogadoId}
      />
    </div>
  );
}

export default Usuario;
